import React from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import { NotificationProvider } from "../contexts/NotificationContext";

import Home from "../view/screens/Home/Home";
import Store from "../view/screens/Store/Store";
import DocsSend from "../view/screens/DocsSend/DocsSend";
import EditData from "../view/screens/EditData/EditData";
import FormNF from "../view/screens/FormNF/FormNF";
import NewAccountForm from "../view/screens/NewAccountForm/NewAccountForm";
import NewAccountSucess from "../view/screens/NewAccountSucess/NewAccountSucess";
import Notification from "../view/screens/Notification/Notification";
import Privacy from "../view/screens/Privacy/Privacy";
import Regulation from "../view/screens/Regulation/Regulation";
import DeleteAccount from "../view/screens/DeleteAccount/DeleteAccount";
import Support from "../view/screens/Support/Support";
import SaveNF from "../view/screens/SaveNF/SaveNF";
import Recommendation from "../view/screens/Recommendation/Recommendation";
import Login from "../view/screens/Login/Login";
import Profile from "../view/screens/Profile/Profile";
import ChangePassword from "../view/screens/ChangePassword/ChangePassword";
import EditAdress from "../view/screens/EditAdress/EditAdress";
import ForgetPassword from "../view/screens/ForgetPassword/ForgetPassword";
import PrizeRedeemed from "../view/screens/PrizeRedeemed/PrizeRedeemed";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Rotas Públicas */}
      <Route path="/" element={<Login />} />
      <Route path="/cadastro" element={<NewAccountForm />} />
      <Route path="/cadastro-realizado" element={<NewAccountSucess />} />
      <Route path="/politicas-de-privacidade" element={<Privacy />} />
      <Route path="/regulamento" element={<Regulation />} />
      <Route path="/deletar-conta" element={<DeleteAccount />} />
      <Route path="/suporte" element={<Support />} />
      <Route path="/recuperar-senha" element={<ForgetPassword />} />

      {/* Rotas Protegidas */}
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />

      {/* Rotas Protegidas com level_id = 3 */}
      <Route
        path="/loja"
        element={
          <PrivateRoute requiredLevelId={3}>
            <Store />
          </PrivateRoute>
        }
      />
      <Route
        path="/documentos-enviados"
        element={
          <PrivateRoute requiredLevelId={3}>
            <DocsSend />
          </PrivateRoute>
        }
      />
      <Route
        path="/editar-dados"
        element={
          <PrivateRoute requiredLevelId={3}>
            <EditData />
          </PrivateRoute>
        }
      />
      <Route
        path="/editar-endereco"
        element={
          <PrivateRoute requiredLevelId={3}>
            <EditAdress />
          </PrivateRoute>
        }
      />
      <Route
        path="/alterar-senha"
        element={
          <PrivateRoute requiredLevelId={3}>
            <ChangePassword />
          </PrivateRoute>
        }
      />

      {/* Rotas Protegidas com `NotificationProvider` */}
      <Route
        path="/notificacao"
        element={
          <PrivateRoute requiredLevelId={3}>
            <NotificationProvider>
              <Notification />
            </NotificationProvider>
          </PrivateRoute>
        }
      />

      <Route
        path="/documento-cadastrado"
        element={
          <PrivateRoute requiredLevelId={3}>
            <SaveNF />
          </PrivateRoute>
        }
      />
      <Route
        path="/recomendacao"
        element={
          <PrivateRoute requiredLevelId={3}>
            <Recommendation />
          </PrivateRoute>
        }
      />
      <Route
        path="/premio-resgatado"
        element={
          <PrivateRoute requiredLevelId={3}>
            <PrizeRedeemed />
          </PrivateRoute>
        }
      />

      {/* Rotas Protegidas com level_id = 3 e role 'attendant' */}
      <Route
        path="/cadastro-de-nota-fiscal"
        element={
          <PrivateRoute requiredLevelId={3} requiredRoles={["attendant"]}>
            <FormNF />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
